export default [
    {
      path: '/plans/support-devices/list',
      name: 'plans.supportDevice.list',
      component: () => import('@/views/modules/plans/support-device-plan/plans-list/SupportDevicesPlans'),
      meta: {
        module: 'plans.supportDevice',
        pageTitle: 'List All Support Devices Plans',
        breadcrumb: [
          { text: 'List Support Devices Plans', active: true, },
         
        ],
      }
    },
  
  
   
  ]
  